var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-item p-3" }, [
    _c("div", { staticClass: "contact-form-action" }, [
      _c("h3", { staticClass: "title mb-3" }, [
        _vm._v("Kredi  : " + _vm._s(_vm._f("toCurrency")(_vm.credit)) + " "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-box" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("base-edit-input", {
                attrs: {
                  rules: "required|min_value:1",
                  type: "number",
                  label: "Miktar",
                },
                model: {
                  value: _vm.amount,
                  callback: function ($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-box" }, [
        _c(
          "button",
          {
            staticClass: "theme-btn theme-btn-danger-rgb",
            attrs: { type: "button" },
            on: { click: _vm.remove },
          },
          [_vm._v("Çıkar")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "theme-btn",
            attrs: { type: "button" },
            on: { click: _vm.add },
          },
          [_vm._v("Ekle")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }